import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import echarts from 'echarts';
@Component({
  selector: 'icc-trend-send',
  templateUrl: './icc-trend-send.component.html',
  styleUrls: ['./icc-trend-send.component.less'],
})
export class IccTrendSendComponent implements OnInit, OnDestroy {
  constructor(private el: ElementRef) {}
  // 图谱实例
  chartIns: any;
  unit: string;
  // 数据源
  @Input() reportType: number;
  @Input() title: string;
  @Input() dateList: Array<string>;
  @Input() receiveList: Array<number>;
  @Input() sendList: Array<number>;
  @Input() ratioList: Array<number>;
  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };
  // 动态自适应调整 Y 轴单位函数
  changeYaxisUnit() {
    // 判断传入数据的接收量和提交量的大小，动态调整 Y 轴单位
    let maxNumber = Math.max(...this.receiveList);
    if (maxNumber < 1000) {
      // 0~1000条，单位为 “条”
      this.unit = '条';
    } else if (maxNumber >= 1000 && maxNumber < 100000) {
      // 1000～100,000条，单位为 “百条”
      this.receiveList = this.receiveList.map(item => item / 100);
      this.sendList = this.sendList.map(item => item / 100);
      this.unit = '百条';
    } else if (maxNumber >= 100000 && maxNumber < 1000000) {
      // 100,000～1000,000条，单位为 “千条”
      this.receiveList = this.receiveList.map(item => item / 1000);
      this.sendList = this.sendList.map(item => item / 1000);
      this.unit = '千条';
    } else {
      // 大于 1000,000，单位为 “万条”
      this.receiveList = this.receiveList.map(item => item / 10000);
      this.sendList = this.sendList.map(item => item / 10000);
      this.unit = '万条';
    }
    // 输出测试
    // console.log('receiveList:' + this.receiveList);
    // console.log('sendList:' + this.sendList);
    // console.log('单位: ' + this.unit);
  }
  ngOnInit() {
    if (this.dateList instanceof Array && this.dateList.length) {
      setTimeout(() => {
        if (this.dateList.length < 10) {
          this.createLineChart('chart-el');
        } else {
          this.createLineChart('chart-el', this.formatRatioList());
        }
      }, 100);
    }
    this.changeYaxisUnit();
    window.addEventListener('resize', this.resizeCharts);
  }
  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }
  formatRatioList() {
    const result = [];
    if (this.ratioList instanceof Array) {
      this.ratioList.forEach(val => {
        result.push({
          value: val,
          label: {
            show: true,
            color: 'rgb(63,63,63)',
            formatter: item => {
              return item.value + '%';
            },
          },
        });
      });
    }
    return result;
  }
  /* 生成图谱 */
  createLineChart(chartCls, ratioList?) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    const legendItem = {
      itemHeight: 10,
      itemGap: 40,
      align: 'right',
      textStyle: {
        color: '#B4B4B4',
      },
    };
    const axisLabel: any = {
      textStyle: {
        color: '#333',
      },
      formatter: '{value} ',
      margin: 20,
    };
    if (this.dateList.length >= 10) {
      axisLabel.margin = 10;
      axisLabel.interval = 0;
      axisLabel.rotate = 60;
    }
    // 设置图表参数
    this.chartIns.setOption({
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
      legend: [
        {
          itemWidth: 30,
          data: [
            {
              name: '成功率',
            },
          ],
          left: '30%',
          ...legendItem,
        },
        {
          itemWidth: 10,
          data: [
            {
              name: '接收量',
              icon: 'rect',
            },
          ],
          ...legendItem,
        },
        {
          itemWidth: 10,
          right: '30%',
          data: [
            {
              name: '提交量',
              icon: 'rect',
            },
          ],
          ...legendItem,
        },
      ],
      grid: {
        x: '8%',
        width: '82%',
        y: '12%',
        top: '20%',
      },
      xAxis: [
        {
          data: this.dateList,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel,
        },
      ],
      yAxis: [
        {
          name: `单位: ${this.unit}`,
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B4B4B4',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#B4B4B4',
            },
            formatter: '{value} ',
          },
        },
        {
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: '{value} %',
            textStyle: {
              color: '#B4B4B4',
            },
          },
        },
      ],
      series: this.getSeries(ratioList),
    });
  }

  getSeries(ratioList) {
    const seriesList: any = [
      {
        name: '成功率',
        type: 'line',
        symbolSize: 1,
        yAxisIndex: 1,
        itemStyle: {
          normal: {
            color: 'rgb(52,163,255)',
          },
        },
        data: ratioList ? ratioList : this.ratioList,
      },
      {
        name: '接收量',
        type: 'bar',
        markPoint: {
          data: [
            {
              name: '最大',
              type: 'max',
            },
            {
              name: '最小',
              type: 'min',
            },
          ],
        },
        yAxisIndex: 0,
        itemStyle: {
          normal: {
            color: 'rgb(52,163,255)',
          },
        },
        data: this.receiveList,
      },
      {
        name: '提交量',
        type: 'bar',
        barGap: '-100%',
        yAxisIndex: 0,
        itemStyle: {
          normal: {
            color: 'rgb(36,212,163)',
          },
        },
        data: this.sendList,
      },
    ];
    seriesList[1].barWidth = 30;
    seriesList[2].barWidth = 30;
    return seriesList;
  }
}
